import clsx from 'clsx';

export const bannerBase = clsx(
  'bg-[--banner-bg] rounded-[--corner-md]',
  'px-[--padding-md] py-[--padding-lg]',
  'flex flex-col items-start gap-[--padding-lg]',
  'w-full'
);

export const bannerTitle = clsx(
  'font-[--font-primary] font-primary font-normal tracking-[--spacing-letters-zero] off-font-liga-clig',
  'text-[--banner-text]',
  'text-[28px] leading-[32px]'
);

export const bannerBody = clsx(
  'font-[--font-primary] font-normal text-[14px] leading-[20px] tracking-[--spacing-letters-zero]',
  'text-[--banner-text]'
);
